module.exports = __webpack_public_path__ + "img/om.6c087a07.svg";